module.exports = __webpack_public_path__ + "img/9.61ba1c57.jpg";